<template>
  <div class="data_body">
    <div class="title">读者借阅排行</div>
    <div style="width: 100%; height: calc(100% - 50px);overflow: auto;">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#E0EAFB', color: '#000' }"
        :row-class-name="tableRowClassName" class="tableClass">
        <el-table-column label="排行" min-width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="name" label="借阅人" min-width="80" align="center">
        </el-table-column>
        <el-table-column prop="sum" label="借阅数量" min-width="80" align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    courseNumberArray: {
      type: Array,
    },
  },
  data() {
    return {
      tableData: [
        { name: "华宇峰", sum: "347" },
        { name: "张涵予", sum: "321" },
        { name: "梁思成", sum: "252" },
        { name: "陈信安", sum: "150" },
        { name: "徐丽佳", sum: "148" },
        { name: "宋佳佳", sum: "130" },
      ],
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "even_row";
      } else {
        return "";
      }
    },
    setArray(array) {
      this.tableData = []
      for (var i = 0; i < array.length; i++) {
        this.tableData.push({
          sum: array[i].course,
          name: array[i].name
        })
      }
      this.tableData = this.tableData.sort(function (a, b) {
        return b.sum - a.sum;
      })
    }
  },
  watch: {
    courseNumberArray: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        // this.setArray(newValue)
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    // this.setArray(this.courseNumberArray)
  },
};
</script>

<style scoped>
.el-table>>>.even_row {
  background-color: #f2f7ff !important;
}

.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  background: #fff;
}

.tableClass>>>td,
.tableClass>>>th {
  padding: 5px 0;
}

.title {
  font-size: 16px;
  text-align: right;
  font-weight: 700;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardSies/library/cateRank/index.vue